var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$hasFeatureFlag(_vm.$featureFlags.fairUseChanges))?_c('TrialModalV2',_vm._b({attrs:{"data-test-id":_vm.$testId('trialModalV2')}},'TrialModalV2',_vm.$attrs,false)):_c('TrialModalV1',_vm._b({attrs:{"data-test-id":_vm.$testId('trialModalV1')}},'TrialModalV1',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }